// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"cb34906a","6850":"d5debde0","6942":"69911358","9205":"ccd34592"}[chunkId] + ".chunk.css";
};